import { useSetOverlayState } from './store/use-set-overlay-state.js';

export const useOverlayHandlers = () => {
  const { setOverlayStateInBounds } = useSetOverlayState();

  const onMouseEnterHandler = () => {
    setOverlayStateInBounds(true);
  };

  const onMouseLeaveHandler = () => {
    setOverlayStateInBounds(false);
  };

  return {
    onMouseEnterHandler,
    onMouseLeaveHandler,
  };
};
